import axios from 'axios';

export default {
    async createCashtransaction(courierinfoId, dataParams) {
        return axios.post(
            `api/courierinfos/${courierinfoId}/cashtransactions`,
            dataParams
        );
    },
    async updateCashtransaction(cashtransactionId, dataParams) {
        return axios.put(
            `api/cashtransactions/${cashtransactionId}`,
            dataParams
        );
    },
    async deleteCashtransaction(cashtransactionId) {
        return axios.delete(`api/cashtransactions/${cashtransactionId}`);
    }
};
